const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/shrink-wrapping-machines`,
    saveSpeedTable: `${API_URL}/shrink-wrapping-machine/save-speed-table`,
    information: `${API_URL}/shrink-wrapping-machine/information`
};

export default apiUrls;
